import React from 'react';
import {px} from '@packages/systems/core/utils/WebflowCssSubset';
import {
  SHARED_DYN_WRAPPER_CONSTRAINTS_ANCESTORS,
  SHARED_DYN_WRAPPER_CONSTRAINTS_DESCENDANTS,
} from '@packages/systems/core/constants/SharedConstraintRules';

import {Atom, Plugins} from '@packages/systems/wfdl';
import {iconName, qualify} from '@packages/systems/wfdl-Qualified';

import {TListOfElement} from '@packages/systems/wfdl-ast';
import {createIntegratedAtom} from '@packages/utilities/integrated-types';
import {EvaluatedNodeData, getChildren} from '@packages/utilities/data-utils';

const CommerceDownloadsWrapper = Atom.createRender(
  ({attributes, classes, data, generateAttributes, renderChild}) => {
    return (
      <div {...generateAttributes(attributes, classes)}>
        {getChildren(data).map((child: EvaluatedNodeData) =>
          renderChild(child)
        )}
      </div>
    );
  }
);

const config = createIntegratedAtom({
  displayName: 'Downloads',
  icon: {
    type: 'Component',
    value: qualify(Plugins.name('Commerce'), iconName('Downloads')),
  },
  showEmpty: false,
  render: CommerceDownloadsWrapper,
  constraints: {
    descendants: [
      ...SHARED_DYN_WRAPPER_CONSTRAINTS_DESCENDANTS,
      {is: 'CommerceDownloadsList', rule: 'ExactlyOne'},
      {is: 'CommerceDownloadsItem', rule: 'ExactlyOne'},
    ],
    ancestors: [
      ...SHARED_DYN_WRAPPER_CONSTRAINTS_ANCESTORS.filter(
        (constraint) => constraint.is !== 'CommerceOrderConfirmationContainer'
      ),
      {is: 'CommerceOrderConfirmationContainer', rule: 'ExactlyOne'},
    ],
  },
  style: {
    base: {
      main: {
        noPseudo: {
          marginBottom: px(20),
        },
      },
    },
  },
  fields: {
    children: TListOfElement,
  },
});

export default config;
